import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { TenantContextService } from 'src/core/services/tenant-context/tenant-context.service';

// Sin tenant resuelto no se renderiza ninguna vista funcional del portal.
export const tenantGuard: CanActivateChildFn = () => {
  const tenant = inject(TenantContextService);
  const router = inject(Router);

  return tenant.companyId() ? true : router.createUrlTree(['/invalid-link']);
};
